var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "24px",
    viewBox: "0 0 17 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_padlock_2799479") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.682353 0 0 0 0 0.376471 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_padlock_2799479",
    transform: "translate(-608.000000, -458.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(608.000000, 458.000000)",
    id: "Group",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05882353,9.70719603 L2.88235294,9.70719603 L2.88235294,5.65756824 C2.88235294,2.56079404 5.41176471,0 8.47058824,0 C11.5882353,0 14.0588235,2.56079404 14.0588235,5.65756824 L14.0588235,9.70719603 L14.8823529,9.70719603 C16.0588235,9.70719603 17,10.6600496 17,11.8511166 L17,21.8560794 C17,23.0471464 16.0588235,24 14.8823529,24 L2.05882353,24 C0.941176471,24 0,23.0471464 0,21.8560794 L0,11.8511166 C0,10.6600496 0.941176471,9.70719603 2.05882353,9.70719603 Z M3.88235294,9.70719603 L13.0588235,9.70719603 L13.0588235,5.65756824 C13.0588235,3.09677419 11,1.01240695 8.47058824,1.01240695 C5.94117647,1.01240695 3.88235294,3.09677419 3.88235294,5.65756824 L3.88235294,9.70719603 Z M14.8823529,10.719603 L2.05882353,10.719603 C1.47058824,10.719603 1,11.2555831 1,11.8511166 L1,21.8560794 C1,22.4516129 1.47058824,22.9875931 2.05882353,22.9875931 L14.8823529,22.9875931 C15.4705882,22.9875931 16,22.4516129 16,21.8560794 L16,11.8511166 C16,11.2555831 15.4705882,10.719603 14.8823529,10.719603 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17647059,17.2109181 C5,17.0322581 5,16.674938 5.17647059,16.4962779 C5.41176471,16.3176179 5.70588235,16.3176179 5.88235294,16.4962779 L7.52941176,18.1042184 L11.0588235,14.5310174 C11.2352941,14.3523573 11.5882353,14.3523573 11.7647059,14.5310174 C11.9411765,14.7096774 11.9411765,15.0669975 11.7647059,15.2456576 L7.88235294,19.1761787 C7.64705882,19.4143921 7.35294118,19.4143921 7.17647059,19.1761787 L5.17647059,17.2109181 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.73051e5aa472301a680c437edba910a0.svg";
export { ForwardRef as ReactComponent };